<template>
<div>
  <article class="sign-in" v-if="!isAuthenticated">
    <div class="wrapper">
      <h1>Quarantrivia</h1>
      <div id="firebaseui-auth-container"></div>
    </div>
  </article>
  <div v-if="isAuthenticated">
    <article class="table">
      <div class="wrapper">
        <h3>Quizzes</h3>
          <table>
            <thead>
              <tr>
                <th>Quiz Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="quiz in quizzes" v-bind:key="quiz.quizName">
                <td><a href="javascript:void(0);" v-on:click="selectQuiz(quiz)">{{quiz.quizTitle || quiz.quizName}}</a></td>
              </tr>
            </tbody>
          </table>
          <p><button type="button" v-on:click="createQuiz()">Create Quiz</button></p>
      </div>
    </article>
    
    <article v-if="selectedQuiz">
      <div class="wrapper">
        <form v-on:submit.prevent="saveQuiz">
          <h3>Enter a Quiz Name</h3>
          <p>Letters and numbers only with no spaces</p>
          <div class="item floatLabel">
            <label for="quiz-name">Quiz Name</label>
            <input type="text" id="quiz-name" v-model="selectedQuiz.quizTitle" />
          </div>
          <div class="item floatLabel">
            Venmo ID (to show Buy a Beer Button)<br />
            <label for="quiz-name">Venmo ID (to show Buy a Beer Button)</label>
            <input type="text" id="quiz-name" v-model="selectedQuiz.venmoId" />
            <ol>
              <li>Select profile icon</li>
              <li>Select QR code from dropdown</li>
              <li>Tap to share</li>
              <li>Select copy from the share options</li>
              <li>Paste information and type in the 19 digit ID</li>
            </ol>
          </div>
          <div class="item floatLabel">
            Venmo Name (for "Buy {name} a beer")<br />
            <label for="quiz-name">Venmo Name (for "Buy {name} a beer")</label>
            <input type="text" id="quiz-name" v-model="selectedQuiz.venmoName" />
          </div>
          <p>
            Admin URL: <a v-bind:href="'https://quarantrivia.app/admin/' + selectedQuiz.quizName" target="_blank">https://quarantrivia.app/admin/{{selectedQuiz.quizName}}</a><br />
            Player URL: <a v-bind:href="'https://quarantrivia.app/' + selectedQuiz.quizName" target="_blank">https://quarantrivia.app/{{selectedQuiz.quizName}}</a><br />
            Viewer URL: <a v-bind:href="'https://quarantrivia.app/' + selectedQuiz.quizName + '/view'" target="_blank">https://quarantrivia.app/{{selectedQuiz.quizName}}/view</a>
          </p>
          <p v-if="selectedQuiz.activeRound">
            <button type="button" v-on:click="resetQuizState()">Replay Quiz</button><br />
            (this resets questions in player view)
          </p>
          <div class="round" v-for="round in selectedQuiz.rounds" v-bind:key="round.roundId">
            <h3>Round {{round.roundId}}</h3>

            <div class="item floatLabel">
              Round Title
              <label>Round Title</label>
              <input type="text" v-model="round.roundTitle" />
            </div>
            <div class="item floatLabel">
              Round Intro
              <label>Round Intro</label>
              <input type="text" v-model="round.roundIntro" />
            </div>
            <div class="item floatLabel">
              Max Points
              <label>Max Points</label>
              <input type="text" v-model="round.maxPoints" />
            </div>

            <div class="question" v-for="(question, index) in round.questions" v-bind:key="question.questionId">
              <p>Question {{index+1}} <a href="javascript:void(0);" v-on:click="removeQuestion(round, question)">Remove Question</a></p>
              <p>Type: <select v-model="question.type">
                <option value="text">Text</option>
                <option value="multiline">Multi-line</option>
                <option value="image">Image</option>
                <option value="mp3">MP3</option>
              </select></p>
              <div class="item floatLabel">
                <textarea v-model="question.question" style="height: 50px;" placeholder="Question"></textarea>
                <textarea v-model="question.answer" style="height: 50px;" placeholder="Answer"></textarea>
                <textarea v-if="question.type=='image' || question.type=='mp3'" v-model="question.src" style="height: 50px;" placeholder="Source"></textarea>
                <textarea v-if="question.type=='image' || question.type=='mp3'" v-model="question.additionalText" style="height: 100px;" placeholder="Additional Text"></textarea>
                <p v-if="question.type=='image' || question.type=='mp3'">Upload File: <input type="file" style="width: 200px;" id="input" @change="filesChange(question, $event.target.files)" /> (jpeg or png only)</p>
              </div>
            </div>
            <p><button type="button" v-on:click="addQuestion(round)">Add Question</button></p>
          </div>

          <p><button type="button" v-on:click="addRound(selectedQuiz)">Add Round</button></p>
                
          <div class="buttons">
            <p v-if="saveSuccessful === true">Save Successful</p>
            <p v-if="saveSuccessful === false">Error Saving!</p>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </article>
  </div>
</div>
</template>

<script>
import firebaseservice from '../services/firebaseservice';
import Vue from 'vue';
export default {
  data: function() {
    return {
      isAuthenticated: false,
      user: null,
      quizzes: [],
      selectedQuiz: null,
      selectedQuizAnswers: [],
      saveSuccessful: null,
    };
  },
  methods: {
    selectQuiz: function(quiz) {
      this.selectedQuiz = quiz;
      firebaseservice.watchQuizAnswers(quiz, (answers) => {
        for (var i=0; i<quiz.rounds.length; i++) {
          const round = quiz.rounds[i];
          for (var j=0; j<round.questions.length; j++) {
            const question = round.questions[j];
            for (var k=0; k<answers.correctAnswers.length; k++) {
              if (answers.correctAnswers[k].questionId == question.questionId) {
                Vue.set(question, 'answer', answers.correctAnswers[k].answer);
              }
            }
          }
        }
      });
    },
    addQuestion: function(round) {
      round.questions.push({
        type: "text",
        questionId: "round" + round.roundId + "-" + (round.questions.length+1),
        hasBeenRead: false,
        question: "",
        answer: "",
      });
    },
    removeQuestion(round, question) {
      for (var i=0; i<round.questions.length; i++) {
        if (round.questions[i] === question) {
          round.questions.splice(i, 1);
        }
      }
    },
    addRound: function(quiz) {
      quiz.rounds.push({
        roundId: quiz.rounds.length+1,
        roundTitle: "",
        roundIntro: "",
        maxPoints: 0,
        questions: [],
      });
      this.addQuestion(quiz.rounds[quiz.rounds.length-1]);
    },
    removeRound(quiz, round) {
      for (var i=0; i<quiz.rounds.length; i++) {
        if (quiz.rounds[i] === round) {
          quiz.rounds.splice(i, 1);
        }
      }
    },
    saveQuiz: async function() {
      this.saveSuccessful = await firebaseservice.upsertQuiz(this.selectedQuiz, true);
      var _this = this;
      setTimeout(() => {
        _this.saveSuccessful = null;
      }, 5000);
    },
    createQuiz: function() {
      var quizName = this.user.uid.substring(20).toString().toLowerCase();
      quizName += Date.now().toString().substring(8);
      var quiz = {
        active: true,
        activeRound: 0,
        quizName: quizName,
        quizTitle: quizName,
        venmoId: null,
        venmoName: null,
        rounds: []
      };
      this.quizzes.push(quiz);
      this.selectedQuiz = quiz;
    },
    resetQuizState: function() {
      this.selectedQuiz.activeRound = 0;
      for (var i=0; i<this.selectedQuiz.rounds.length; i++) {
        const round = this.selectedQuiz.rounds[i];
        for (var j=0; j<round.questions.length; j++) {
          const question = round.questions[j];
          question.hasBeenRead = false;
        }
      }
      firebaseservice.upsertQuiz(this.selectedQuiz, true);
    },
    filesChange: async function(question, files) {
      var url = await firebaseservice.uploadFile(this.selectedQuiz, files[0]);
      Vue.set(question, 'src', url);
    }
  },
  mounted: function() {
    var _this = this;
    firebaseservice.watchUser((user) => {
      _this.user = user;
      _this.isAuthenticated = (user != null);
      firebaseservice.watchQuizzes((quizzes) => {
        _this.quizzes = quizzes;
      });
    })
    var ui = new window.firebaseui.auth.AuthUI(window.firebase.auth());
    ui.start('#firebaseui-auth-container', {
      signInOptions: [
          window.firebase.auth.FacebookAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: function() {
          return false;
        },
      },
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
